// composables/useScroller.ts
import { ref } from 'vue'

export function useScroll() {
    const topActive = ref(false)
    const bottomActive = ref(true)

    function onVerticalScroll(e: Event) {
        const scroller = e.currentTarget
        if (!(scroller instanceof HTMLElement)) {
            return
        }

        const bottomReached = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1
        const topReached = scroller.scrollTop > 0

        topActive.value = topReached
        bottomActive.value = !bottomReached
    }

    return {
        topActive,
        bottomActive,
        onVerticalScroll,
    }
}
